import React, { useEffect, useRef ,useState} from "react";
import banner1 from '../../../assets/website/images/banner1.png';
import banner2 from '../../../assets/website/images/banner2.png';
import banner3 from '../../../assets/website/images/banner3.png';
import whyImg from '../../../assets/website/images/why-img.jpg';

import industries1 from '../../../assets/website/images/industries1.jpg';
import industries2 from '../../../assets/website/images/industries2.jpg';
import industries3 from '../../../assets/website/images/industries3.jpg';
import industries4 from '../../../assets/website/images/industries4.jpg';
import HowWorkImg from '../../../assets/website/images/how-work-img.jpg';

import { createSlider } from '../../../utils/commonfunction';
// import banner from "../../../assets/website/images/main-banner.png";
// import about from "../../../assets/website/images/about.png";
// import successOverview from "../../../assets/website/images/successOverview.jpeg";
import WebsiteBanners from "../common/banner";
import WebsiteFeaturedRestaurant from "../common/featuredrestaurants";
import WebsiteTestimonials from "../common/websitetestimonials";
import { useTranslation } from "react-i18next";
import Inquiry from "../common/inquiry";
import { useSelector } from "react-redux";
import { setTitle } from "../../../utils/commonfunction";
import WebsiteFeaturedOutlet from "../common/featuredrestaurants";
import { Link, useLocation } from "react-router-dom";
function WebsiteHomePage() {
  const { t } = useTranslation();
  const BannerHomeSliderRef = useRef();
  const BannerHomeSliderRef2 = useRef();
  const BannerHomeSliderRef3 = useRef();
  const location = useLocation();
  const [getGlobalData, setGlobalData] = useState({});
  const howItWorksRef = useRef();
  const myGlobalData = useSelector((state) => state.globalData?.data);

  useEffect(() => {
    if (myGlobalData) {
      const settingsData = JSON.parse(myGlobalData);
      setGlobalData(settingsData);
      setTitle(settingsData.title);
    }
   
  }, [myGlobalData]);

  useEffect(() => {
    if (howItWorksRef.current && window.location.hash.includes("#how-it-work")) {
      const body = document.querySelector('body, html');
      if(body.scrollTop <= 10){
        body.scrollTop = howItWorksRef.current?.offsetTop || 0;
      }
    }
   
  }, [howItWorksRef.current, location]);

  useEffect(() => {
    if (BannerHomeSliderRef?.current) {
      createSlider(`#BannerHomeSliderRef`, {
        loop: true,
        margin: 20,
        nav: true,
        dots: false,
        responsive: {
          0: {
            items: 1
          },
          600: {
            items: 2
          },
          1000: {
            items: 3
          }
        }
      });
    }
  }, [BannerHomeSliderRef]);

  useEffect(() => {
    if (BannerHomeSliderRef2?.current) {
      createSlider(`#BannerHomeSliderRef2`, {
        loop: true,
        margin: 20,
        nav: true,
        dots: false,
        responsive: {
          0: {
            items: 1
          },
          600: {
            items: 3
          },
          1000: {
            items: 4
          }
        }
      });
    }
  }, [BannerHomeSliderRef2]);

  useEffect(() => {
    if (BannerHomeSliderRef3?.current) {
      createSlider(`#BannerHomeSliderRef3`, {
        loop: true,
        margin: 20,
        nav: true,
        dots: true,
        responsive: {
          0: {
            items: 1
          },
          600: {
            items: 1
          },
          1000: {
            items: 1
          }
        }
      });
    }
  }, [BannerHomeSliderRef3]);
  return (
    <div className="home-page-section">
      <section className="home-hero-section">
        <div className="home-hero-section-in">
          <div className="container">
            <div className="home-hero-text">
              <h6>{t("website.home.web_heading")}</h6>
              <h1>{t("website.home.web_sub_heading")}</h1>
              <p>{t("website.home.web_main_content")}</p>
              <Link to={`/inquiry`} className="btn btn-primary">{t("website.home.web_nav_link_inquire_now")}</Link>
            </div>
          </div>
        </div>
      </section>
      <WebsiteBanners id="banner1" />

      {/* <section className="section-padding">
        <div className="container">
          <div className="offer-banner-slider owl-carousel owl-theme enable-nav-flex" id={"BannerHomeSliderRef"} ref={BannerHomeSliderRef}>
          <div className="itme">
              <figure>
                <img src={banner1} alt="Pouring coffee" className="img-fluid" />
              </figure>
            </div>
            <div className="itme">
              <figure>
                <img src={banner2} alt="Pouring coffee" className="img-fluid" />
              </figure>
            </div>
            <div className="itme">
              <figure>
                <img src={banner3} alt="Pouring coffee" className="img-fluid" />
              </figure>
            </div>
          </div>
        </div>
      </section> */}
      <section id="about_us" className="why-choose-sec section-padding">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-md-5">
              <div className="why-choose-text">
                <div className="heading-section d-flex flex-column gap-3 mb-5">
                  <h4>{t("website.home.web_why_choose_alvyn_epos")}</h4>
                  <p>{t("website.home.web_why_choose_alvyn_epos_content")}</p>
                </div>
                <div className="why-choose-point d-flex row m-0">
                  <article>
                    <figure>
                      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M30 31.4329H28.7333C27.4 31.4329 26.1333 31.9496 25.2 32.8829L22.35 35.6997C21.05 36.983 18.9333 36.983 17.6333 35.6997L14.7833 32.8829C13.85 31.9496 12.5667 31.4329 11.25 31.4329H10C7.23333 31.4329 5 29.2163 5 26.4829V8.29956C5 5.56623 7.23333 3.34961 10 3.34961H30C32.7667 3.34961 35 5.56623 35 8.29956V26.4829C35 29.1996 32.7667 31.4329 30 31.4329Z" stroke="#E42375" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M11.667 15.267C11.667 13.717 12.9337 12.4502 14.4837 12.4502C16.0337 12.4502 17.3003 13.717 17.3003 15.267C17.3003 18.4003 12.8503 18.7336 11.867 21.717C11.667 22.3336 12.1837 22.9503 12.8337 22.9503H17.3003" stroke="#E42375" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M26.7339 22.9331V13.4165C26.7339 12.9832 26.4506 12.5997 26.0339 12.4831C25.6172 12.3664 25.1673 12.5331 24.9339 12.8997C23.7339 14.8331 22.4339 17.0331 21.3006 18.9664C21.1173 19.2831 21.1173 19.6998 21.3006 20.0164C21.4839 20.3331 21.8339 20.533 22.2173 20.533H28.3339" stroke="#E42375" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </figure>
                    <figcaption>
                      <h4>{t("website.home.web_why_choose_alvyn_epos_support")}</h4>
                    </figcaption>
                  </article>
                  <article>
                    <figure>
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M34.8504 18.5332C34.8504 26.6832 28.9337 34.3165 20.8504 36.5498C20.3004 36.6998 19.7004 36.6998 19.1504 36.5498C11.067 34.3165 5.15039 26.6832 5.15039 18.5332V11.2165C5.15039 9.84981 6.18375 8.29982 7.46708 7.78315L16.7504 3.9832C18.8337 3.1332 21.1837 3.1332 23.267 3.9832L32.5504 7.78315C33.8171 8.29982 34.8671 9.84981 34.8671 11.2165L34.8504 18.5332Z" stroke="#E42375" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M20.0003 20.8337C21.8413 20.8337 23.3337 19.3413 23.3337 17.5003C23.3337 15.6594 21.8413 14.167 20.0003 14.167C18.1594 14.167 16.667 15.6594 16.667 17.5003C16.667 19.3413 18.1594 20.8337 20.0003 20.8337Z" stroke="#E42375" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M20 20.834V25.834" stroke="#E42375" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </figure>
                    <figcaption>
                      <h4>{t("website.home.web_why_choose_alvyn_epos_secure")}</h4>
                    </figcaption>
                  </article>
                  <article>
                    <figure>
                      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.2663 18.1163C15.0996 18.0997 14.8996 18.0997 14.7163 18.1163C10.7496 17.983 7.59961 14.733 7.59961 10.733C7.59961 6.64967 10.8996 3.33301 14.9996 3.33301C19.0829 3.33301 22.3996 6.64967 22.3996 10.733C22.3829 14.733 19.2329 17.983 15.2663 18.1163Z" stroke="#E42375" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M27.3505 6.66699C30.5838 6.66699 33.1838 9.28366 33.1838 12.5003C33.1838 15.6503 30.6838 18.217 27.5671 18.3337C27.4338 18.317 27.2838 18.317 27.1338 18.3337" stroke="#E42375" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6.9332 24.267C2.89987 26.967 2.89987 31.367 6.9332 34.0503C11.5165 37.117 19.0332 37.117 23.6165 34.0503C27.6499 31.3503 27.6499 26.9503 23.6165 24.267C19.0499 21.217 11.5332 21.217 6.9332 24.267Z" stroke="#E42375" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M30.5664 33.333C31.7664 33.083 32.8997 32.5997 33.8331 31.883C36.4331 29.933 36.4331 26.7163 33.8331 24.7663C32.9164 24.0663 31.7997 23.5997 30.6164 23.333" stroke="#E42375" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </figure>
                    <figcaption>
                      <h4>{t("website.home.web_why_choose_alvyn_epos_user_friendly")}</h4>
                    </figcaption>
                  </article>
                  <article>
                    <figure>
                      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M35 15V5H25" stroke="#E42375" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M5 25V35H15" stroke="#E42375" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M35 5L22.5 17.5" stroke="#E42375" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M17.5 22.5L5 35" stroke="#E42375" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </figure>
                    <figcaption>
                      <h4>{t("website.home.web_why_choose_alvyn_epos_scalable")}</h4>
                    </figcaption>
                  </article>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <figure>
                <img src={whyImg} alt="Pouring coffee" className="img-fluid" />
              </figure>
            </div>
          </div>
        </div>
      </section>

      <section className="industries-sec section-padding">
        <div className="container">
          <div className="heading-section d-flex flex-column gap-3 mb-5 w-50">
            <h4>Multiple Industries We Serve</h4>
            <p>At Alvyn POS, we believe every business deserves a solution tailored to its unique needs. That’s why our powerful, flexible, and scalable Point-of-Sale system is designed to cater to a variety of industries, ensuring seamless operations and growth.</p>
          </div>
          <div className="industries-list">
            <div className="row">
              <div className="col-md-3">
                <article>
                  <figure>
                    <img src={industries1} alt="Pouring coffee" className="img-fluid" />
                  </figure>
                  <figcaption>
                    <h4>Retail</h4>
                    <p>Simplify checkout processes, manage stock in real time, and gain insights into customer preferences.</p>
                  </figcaption>
                </article>
              </div>
              <div className="col-md-3">
                <article>
                  <figure>
                    <img src={industries2} alt="Pouring coffee" className="img-fluid" />
                  </figure>
                  <figcaption>
                    <h4>Food & Beverage</h4>
                    <p>In the fast-paced world of food and beverage, efficiency and customer satisfaction are key.</p>
                  </figcaption>
                </article>
              </div>
              <div className="col-md-3">
                <article>
                  <figure>
                    <img src={industries3} alt="Pouring coffee" className="img-fluid" />
                  </figure>
                  <figcaption>
                    <h4>Café</h4>
                    <p>Streamline orders, manage reservations, and track inventory effortlessly to create a delightful dining experience.</p>
                  </figcaption>
                </article>
              </div>
              <div className="col-md-3">
                <article>
                  <figure>
                    <img src={industries4} alt="Pouring coffee" className="img-fluid" />
                  </figure>
                  <figcaption>
                    <h4>Supermarkets</h4>
                    <p>Handle high-volume sales with ease, track perishables, and manage vendor relationships efficiently.</p>
                  </figcaption>
                </article>
              </div>
            </div>
          </div>
        </div>
      </section>

      <WebsiteFeaturedOutlet />
      {/* <section className="featured-outlets-sec section-padding pt-0">
        <div className="container">
          <div className="heading-section d-flex align-items-center flex-column gap-3 mb-5">
            <h4>Featured outlets</h4>
          </div>
          <div>
          <div className="owl-carousel owl-theme enable-nav-flex" id={"BannerHomeSliderRef2"} ref={BannerHomeSliderRef2}>
            <div className="item">
              <div className="outlets-box">
                <figure>
                  <img src={industries1} alt="Pouring coffee" className="img-fluid" />
                </figure>
                <figcaption>
                  <h4>Noguchi Tsunagu</h4>
                  <p className="d-flex gap-2 align-items-center"><i className="ti ti-map-pin"></i>Kyoto, 605-0084, Japan</p>
                </figcaption>
              </div>
            </div>
            <div className="item">
              <div className="outlets-box">
                <figure>
                  <img src={industries2} alt="Pouring coffee" className="img-fluid" />
                </figure>
                <figcaption>
                  <h4>Noguchi Tsunagu</h4>
                  <p className="d-flex gap-2 align-items-center"><i className="ti ti-map-pin"></i>Kyoto, 605-0084, Japan</p>
                </figcaption>
              </div>
            </div>
            <div className="item">
              <div className="outlets-box">
                <figure>
                  <img src={industries3} alt="Pouring coffee" className="img-fluid" />
                </figure>
                <figcaption>
                  <h4>Noguchi Tsunagu</h4>
                  <p className="d-flex gap-2 align-items-center"><i className="ti ti-map-pin"></i>Kyoto, 605-0084, Japan</p>
                </figcaption>
              </div>
            </div>
            <div className="item">
              <div className="outlets-box">
                <figure>
                  <img src={industries4} alt="Pouring coffee" className="img-fluid" />
                </figure>
                <figcaption>
                  <h4>Narisawa</h4>
                  <p className="d-flex gap-2 align-items-center"><i className="ti ti-map-pin"></i>Minato City, Japan</p>
                </figcaption>
              </div>
            </div>
          </div>
          </div>
        </div>
      </section> */}

      <section id="how-it-work" ref={howItWorksRef} className="how-it-work-sec section-padding">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-md-6">
              <div className="heading-section d-flex flex-column gap-2 mb-5">
                <h6>How it works?</h6>
                <h4>How Does it Operate?</h4>
              </div>
              <div className="how-it-row row">
                <div className="col-md-6">
                  <article>
                    <span>1</span>
                    <h4>Order Entry</h4>
                    <p>At the core of Alvyn POS is an efficient order entry system that ensures seamless management for dine-in, takeaway, and delivery. It maximizes accuracy and speed from the moment the order is placed. </p>
                  </article>
                </div>
                <div className="col-md-6">
                  <article>
                    <span>2</span>
                    <h4>Order Transmission</h4>
                    <p>After an order is entered into Alvyn POS, it is quickly and accurately transmitted to the relevant departments, ensuring seamless communication and faster service. Whether it's the kitchen, bar, or prep station, efficiency is guaranteed.</p>
                  </article>
                </div>
                <div className="col-md-6">
                  <article>
                    <span>3</span>
                    <h4>Order Monitoring</h4>
                    <p>Once an order is placed and transmitted, Alvyn POS ensures effortless monitoring, keeping you on top of every detail for timely and accurate fulfillment. It guarantees a smooth service experience from start to finish.</p>
                  </article>
                </div>
                <div className="col-md-6">
                  <article>
                    <span>4</span>
                    <h4>Order Fulfillment</h4>
                    <p>Alvyn POS streamlines order fulfillment, ensuring accuracy, speed, and customer satisfaction. It’s the final step in delivering an exceptional experience from start to finish. </p>
                  </article>
                </div>
              </div>
            </div>
            <div className="col-md-5">
              <figure>
                <img src={HowWorkImg} alt="Pouring coffee" className="img-fluid" />
              </figure>
            </div>
          </div>
        </div>
      </section>

      <WebsiteTestimonials />
      {/* <section className="testimonial-sec section-padding">
        <div className="container">
          <div className="heading-section d-flex flex-column align-items-center gap-2 mb-5">
            <h6>Our Testimonials</h6>
            <h4>Hear What Our Customers Have To Say</h4>
          </div>
          <div className="owl-carousel owl-theme enable-nav-flex" id={"BannerHomeSliderRef3"} ref={BannerHomeSliderRef3}>
            <div className="item">
                <div className="testimonial-ui">
                  <figure>
                    <img src="https://images.pexels.com/photos/762020/pexels-photo-762020.jpeg?cs=srgb&dl=pexels-olly-762020.jpg&fm=jpg" alt="Pouring coffee" className="img-fluid" />
                  </figure>
                  <figcaption>
                    <div className="testimonial-info">
                      <h4>Michelle Anna</h4>
                      <span>CEO, Co-Founder, XYZ Inc.</span>
                    </div>
                    <p>‘’Donec nibh magna, interdum quis massa sed, rhoncus laoreet quam. Mauris accumsan felis fermentum euismod egestas. Mauris ante augue, cursus sit amet arcu a, maximus suscipit nibh. Integer vel nibh tellus. Pellentesque in risus non dui venenatis sollicitudin sed vitae diam. Fusce tincidunt nisl mi, at molestie odio accumsan non. Pellentesque ma’’
                    </p>
                  </figcaption>
                </div>
            </div>
            <div className="item">
                <div className="testimonial-ui">
                  <figure>
                    <img src="https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?cs=srgb&dl=pexels-pixabay-415829.jpg&fm=jpg" alt="Pouring coffee" className="img-fluid" />
                  </figure>
                  <figcaption>
                    <div className="testimonial-info">
                      <h4>Michelle Anna</h4>
                      <span>CEO, Co-Founder, XYZ Inc.</span>
                    </div>
                    <p>‘’Donec nibh magna, interdum quis massa sed, rhoncus laoreet quam. Mauris accumsan felis fermentum euismod egestas. Mauris ante augue, cursus sit amet arcu a, maximus suscipit nibh. Integer vel nibh tellus. Pellentesque in risus non dui venenatis sollicitudin sed vitae diam. Fusce tincidunt nisl mi, at molestie odio accumsan non. Pellentesque ma’’
                    </p>
                  </figcaption>
                </div>
            </div>
            <div className="item">
                <div className="testimonial-ui">
                  <figure>
                    <img src="https://img.freepik.com/free-photo/portrait-young-asian-woman-profile_641386-436.jpg" alt="Pouring coffee" className="img-fluid" />
                  </figure>
                  <figcaption>
                    <div className="testimonial-info">
                      <h4>Michelle Anna</h4>
                      <span>CEO, Co-Founder, XYZ Inc.</span>
                    </div>
                    <p>‘’Donec nibh magna, interdum quis massa sed, rhoncus laoreet quam. Mauris accumsan felis fermentum euismod egestas. Mauris ante augue, cursus sit amet arcu a, maximus suscipit nibh. Integer vel nibh tellus. Pellentesque in risus non dui venenatis sollicitudin sed vitae diam. Fusce tincidunt nisl mi, at molestie odio accumsan non. Pellentesque ma’’
                    </p>
                  </figcaption>
                </div>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
}

export default WebsiteHomePage;